import React from "react";

export default function HeadingPage(props) {
  return (
    <div>
<h2 className="pl-5 pt-4 text-xl sm:text-2xl md:text-3xl font-bold">
  {props.title}
</h2>
      <h2 className=" absolute  text-sm md:text-md font-bold right-6 top-2 md:top-10 md:right-10">
        {" "}
        Time Spent: {props.timer}
      </h2>
      <button class="bg-blue-500 hover:bg-green-700 text-white font-semibold py-1 px-1 rounded-sm ml-6 mr-3 mt-3">
        {props.difficulty}
      </button>

      <button class="bg-green-500 hover:bg-green-700 text-white font-semibold py-1 px-1 rounded-sm">
        {props.attempted}
      </button>

      <p className="p-4">
        {props.para}
      </p>
    </div>
  );
}
